import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class ProcessStepContextEngine extends ConnectBasicEntity {
contextOnly: boolean | null;
defaultEngineType: string;
engineOperation: string;
processCode: string;
processStepCode: string;
scenario: string;
stepEvent: string;
valueParts: string;
visionCode: string;
}

